import {Injectable} from '@angular/core';
import {createEffect, ofType, Actions} from '@ngrx/effects';
import {catchError, map, mergeMap} from 'rxjs/operators';
import {GetEstateAgentsResponseModel} from '../../../shared/models/users/users.models';
import {of} from 'rxjs';
import {ApiService} from '../../../core/http/api.service';
import { EstateAgentActions } from '../../actions/user/estate-agent.actions';


@Injectable()
export class EstateAgentEffects {

  constructor(
    private actions$: Actions,
    private api: ApiService
  ) {
  }

   loadEstateAgents$ = createEffect(() => this.actions$
    .pipe(
      ofType(EstateAgentActions.loadEstateAgents),
      mergeMap(
        () => this.api.Users.getEstateAgents()
          .pipe(
            map((response: GetEstateAgentsResponseModel) => EstateAgentActions.loadEstateAgentsSuccess(response)),
            catchError(error => of(EstateAgentActions.loadEstateAgentsFailure(error)))
          )
      )
    ));
}
